import { Fragment } from "react";
import * as Scrivito from "scrivito";
import AuthorImage from "../../Components/AuthorImage";
import SchemaDotOrg from "../../Components/SchemaDotOrg";

Scrivito.provideComponent("Author", ({ page }) => (
  <Fragment>
    <section className="bg-white" itemScope itemType="http://schema.org/Person">
      <div className="container">
        <div className="row">
          <div className="col-md-2 col-sm-4 col-xs-4">
            <Scrivito.ContentTag
              content={page}
              attribute="image"
              itemProp="image"
            >
              <AuthorImage image={page.get("image")} />
            </Scrivito.ContentTag>
          </div>
          <div className="col-md-10 col-sm-8 col-xs-8">
            <Scrivito.ContentTag
              content={page}
              attribute="title"
              itemProp="name"
              tag="h1"
              className="h1"
            />
            <Scrivito.ContentTag
              content={page}
              attribute="description"
              tag="h2"
              className="h4"
            />
          </div>
        </div>
      </div>
    </section>
    <SchemaDotOrg content={page} />
  </Fragment>
));
